import type { FaireProductEntity } from "../../entity_types/product";

export const p_tcytd8wpy9: FaireProductEntity = {
  token: "p_tcytd8wpy9",
  type: "product",
  name: "One Palo Santo Bracelet",
  brandToken: "b_pqhb98yzxr",
  brandName: "Mi Esperanza Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/2ddea9ca6cb47eddc1667b4bc3ac128a1c2997991de540dad81dbe12d1b5fc8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/293f7260b83d862a2df5c82a94228b59dac9fec6e4b7ae4cc002d9ada37dcbac.jpeg",
    "https://cdn.faire.com/fastly/58c5960506d5801edb597a941c8e99b384d0a2e50947f47e04288779b18ad5be.jpeg",
    "https://cdn.faire.com/fastly/ff39f91b71f78b6f31301d5234a2f6e7dfa53ef62c2eac92854e4eb4b75dccc6.jpeg",
    "https://cdn.faire.com/fastly/782f3fb343e515af703d534c0e4e4dbae1f108563a64c0d0f6fff95549927f07.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "You will receive 1 Palo Santo Bracelet approximately the same size and quality as the ones pictured. Note that patterns, colors, and shades may vary. (All props shown in the photo are not included, they are only present for display purposes only. You will only receive 1 Bracelet) \n\nBeads measure approximately between 8.2 mm and 8.5 mm.\n",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:46.401Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
